import React, {Component} from 'react'
import {connect} from 'react-redux'
import {getResource} from '../../../data/actions/resource'
import LocalStorage from '../../../util/localStorage'
import Resources from '../../../data/services/resources'
import {Field, FieldsManager} from '../../../data/services/fields'
import {DEFAULT_CRUD_STATE, FIXED_ASSET_TYPES} from '../../../util/util-constants'
import {
    getDefaultTableOptions,
    getDefaultTableOptionsJSON,
    getProp,
    longTableColumn,
    mergeDeep,
    saveTableColumns,
    checkPerm
} from '../../../common/util/util-helpers'
import ActiveFilters from "../../../common/components/resource-table/table-components/active-filters";
import TableSettingsPopOver from "../../../common/components/resource-table/table-components/table-settings-popover";
import TableCard from "../../../common/components/resource-table/table-components/table-card";
import TableFilters from "../../../common/components/resource-table/table-components/table-filters";
import ResourceTable from "../../../common/components/resource-table";
import Pagination from "../../../common/components/resource-table/table-components/pagination";
import NoRecords from "../../../common/components/no-records-found/no-records";
import TableOptionsDialog from "../../../common/components/resource-table/table-components/table-options-dialog";
import TableCardFooter from "../../../common/components/resource-table/table-components/table-card-footer";
import {DEFAULT_DATABASE_DATE_FORMAT, DEFAULT_QUERY_LIMIT, READ_PERM} from '../../../common/util/util-consts'
import {download} from "../../../data/actions/download";
import {currentDate} from "../../../common/util/util-dates";
import Tippy from "@tippyjs/react";
import DocumentArrowDownIcon from "@heroicons/react/20/solid/DocumentArrowDownIcon";
import moment from "moment/moment"
import PayDateFilter from '../carrier-pay/carrier-pay-date-filter'
import ModalDefault from '../../../common/components/modal/modal-default'
import FileViewer from '../../../common/components/file-viewer/components'
import Env from '../../../util/env'
import {getJWT} from '../../../common/util/util-auth'
import {LoaderSmall} from '../../../common/components/loader'
import {genericMoneyFormatter} from '../../../common/util/util-vanilla'
import {excludeFields} from '../../../common/util/util-fields'
import Badge from '../../../common/components/badge';

class SettlementItems extends Component {
    constructor(props) {
        super(props)
        this.pagePath = "accounting/reports/settlement-items"

        this.state = {
            // Default state
            ...DEFAULT_CRUD_STATE,
            sortBy: 'AutoCounter',
            sort: "DESC",

            // PDF viewer
            isPayrollViewDialogOpen: false,
            selectedSettlementItem: null,

            // Fields
            fields: this.getFields(),
            tableOptions: getDefaultTableOptions(this.getFields(), {
                behaviour: {
                    canAdjustWidth: true
                },
                style: {
                    condensed: true,
                },
            }, this.pagePath, this.props.translate),

            // Filter, and header fields
            queryFilterFields: this.getQueryFilterFields(),
        }

        this.state = mergeDeep(this.state, LocalStorage.rehydrateState(this.pagePath))
    }

    /** Lifecycle
     ================================================================= */
    componentDidMount() {
        this.fetchData()
    }

    /** Data Events
     ================================================================= */
    fetchData = () => {
        this.props.dispatch(getResource({
            user: LocalStorage.get('user'),
            resource: this.getResource(),
            query: this.getQuery()
        }))
    }

    downloadExcel = () => {
        this.props.dispatch(download({
            user: LocalStorage.get('user'),
            resource: this.getResource(),
            query: Object.assign({format: 'EXCEL', name: 'settlement_items_' + currentDate() + '.xlsx'}, this.getQuery())
        }))
    }
    /** UI Events
     ================================================================= */
    handleTogglePayrollView = (item = null) => {
        this.setState({
            selectedSettlementItem: item,
            isPayrollViewDialogOpen: !this.state.isPayrollViewDialogOpen
        })
    }

    handleToggleConfirmDialog = (submit) => {
        this.setState({
            confirmModal: submit,
            confirmDialog: !this.state.confirmDialog
        })
    }

    handleUpdateSort = (sortBy) => {
        this.setState({
            sortBy: sortBy,
            sort: (this.state.sortBy === sortBy) ? (this.state.sort === 'ASC' ? 'DESC' : 'ASC') : 'ASC'
        }, () => {
            this.saveFilters()
            this.fetchData()
        })
    }

    handleUpdateOffset = (offset, num) => {
        this.setState({
            offset: offset,
            paginationPage: num
        }, () => {
            this.saveFilters()
            this.fetchData()
        })
    }

    handleLinkClick = (e) => {
        this.props.history.push(e)
    }

    handleFilterInputChange = (name, value) => {
        this.setState({
            queryFilterFields: FieldsManager.updateField(this.state.queryFilterFields, name, value),
            offset: 0,
            paginationPage: 1
        }, () => {
            this.saveFilters()
            this.fetchData()
        })
    }

    handleClearFiltersClick = (excludeAdditional = []) => {
        const queryFilterFields = Object.assign({}, this.state.queryFilterFields)
        const defaultExcludedFields = ['limit']
        const excludedFields = defaultExcludedFields.concat(excludeAdditional)

        Object.values(queryFilterFields).filter(it => !excludedFields.includes(it.name)).forEach(it => {
            FieldsManager.updateField(queryFilterFields, it.name, '')
        })

        this.setState({
            queryFilterFields: queryFilterFields,
            offset: 0,
            paginationPage: 1
        }, () => {
            this.saveFilters()
            this.fetchData()
        })
    }

    updateQueryFields = (queryFilterFields) => {
        this.setState({
            queryFilterFields,
            offset: 0,
            paginationPage: 1
        }, () => {
            this.saveFilters()
            this.fetchData()
        })
    }

    handleSetTableColumnOptions = (columns) => {
        let tableOptions = Object.assign({}, this.state.tableOptions)

        tableOptions.columns = columns.reduce((memo, it) => {
            memo[it.name] = it
            return memo
        }, {})

        this.setState({
            tableOptions,
            columnsModalOpen: false
        }, () => saveTableColumns(this.pagePath, tableOptions))
    }

    getDefaultTableColumnOptions = () => {
        return getDefaultTableOptionsJSON(this.getFields(), {}, this.props.translate)
    }

    handleToggleColumnSettingsDialog = () => {
        this.setState({
            columnsModalOpen: !this.state.columnsModalOpen
        })
    }

    setOptions = (options) => {
        this.setState({
            tableOptions: options
        }, () => saveTableColumns(this.pagePath, options))
    }
    /** Helpers
     ================================================================= */
    saveFilters = () => {
        LocalStorage.persistState(this.pagePath, this.state, ['sortBy', 'sort', 'limit', 'input'])
    }

    getFields = () => {
        return {
            FirstName: new Field('FirstName', '', ['empty'], false, 'text', {
                render: (item) => {
                    return (<div>{item.FirstName} {item.LastName}</div>)
                },
                omitSort: true
            }),
            DriverPositionType: new Field('DriverPositionType', '', ['empty'], false, 'text', {
                omitSort: true
            }),
            AutoCounter: new Field('AutoCounter', '', ['empty'], false, 'text', {
                label: 'batch',
                omitSort: true
            }),
            Date: new Field('Date', '', ['empty'], false, 'date', {
                omitSort: true
            }),
            BookDate: new Field('BookDate', '', ['empty'], false, 'date', {
                label: 'CheckPostingDate',
                omitSort: true
            }),
            Description: new Field('Description', '', ['empty'], false, 'text', {
                omitSort: true
            }),
            Amount: new Field('Amount', '', ['empty'], false, 'money', {
                omitSort: true
            }),
            AccountName: new Field('AccountName', '', ['empty'], false, 'text', {
                omitSort: true
            }),
            Type: new Field('Type', '', [], false, 'custom', {
                omitSort: true,
                render: (item) => <SettlementItemType item={item} translate={this.props.translate}/>
            }),
        }
    }

    getQueryFilterFields = () => {
        return {
            query: new Field('query', '', [''], false, 'search', {}, {}),
            StartDate: new Field('StartDate', moment().subtract(1, 'month').startOf('month').format(DEFAULT_DATABASE_DATE_FORMAT), ['empty'], false, 'date', {}, {}),
            EndDate: new Field('EndDate', moment().subtract(1, 'month').endOf('month').format(DEFAULT_DATABASE_DATE_FORMAT), ['empty'], false, 'date', {}, {}),
            AmountMoreThan: new Field('AmountMoreThan', '', [], false, 'float'),
            AmountLessThan: new Field('AmountLessThan', '', [], false, 'float'),
            DriverPositionTypeID: new Field('DriverPositionTypeID', '', [], false, 'select', {}),
            limit: new Field('limit', DEFAULT_QUERY_LIMIT, [''], false, 'select', {hideLabel: true}, {menuPlacement: 'top'}),
        }
    }

    getQuery = () => {
        return {
            sort: this.state.sort,
            sortBy: this.state.sortBy,
            offset: this.state.offset,

            ...FieldsManager.getFieldKeyValues(this.state.queryFilterFields)
        }
    }

    getResource = () => {
        return Resources.SettlementItems
    }

    /** Render
     ================================================================= */
    render() {
        const {translate, resource} = this.props
        const data = getProp(resource.data, 'list', [])
        const count = getProp(resource.data, 'count', 0)
        const TotalAmount = getProp(resource.data, 'TotalAmount', 0)

        return (
            <React.Fragment>
                <div className="sm:flex mb-2">
                    <ActiveFilters
                        filterFields={this.state.queryFilterFields}
                        onLabelClick={this.handleFilterInputChange}
                        onClearFiltersClick={this.handleClearFiltersClick}
                        translate={translate}
                    />

                    <div className="ml-auto flex sm:justify-start justify-end items-center">
                        <Tippy content={translate('text.download_excel')}>
                            <button
                                className="btn-icon"
                                onClick={this.downloadExcel}
                            >
                                <DocumentArrowDownIcon className="w-5 h-5"/>
                            </button>
                        </Tippy>

                        <div className={'flex mr-4'}>
                            <TableSettingsPopOver
                                options={this.state.tableOptions}
                                setOptions={this.setOptions}
                                toggleColumnSettingsDialog={this.handleToggleColumnSettingsDialog}
                                translate={translate}
                            />
                        </div>
                    </div>
                </div>

                <div className="my-2 text-lg px-1">
                    {resource.isLoading ? (
                        <LoaderSmall addClass="mt-1" disableContainer/>
                    ) : (
                        <div>{translate('text.TotalAmount') + ': ' + genericMoneyFormatter(TotalAmount)}</div>
                    )}
                </div>

                <TableCard addClass={'relative'}>
                    <TableFilters
                        hideLimit
                        filterFields={excludeFields(this.state.queryFilterFields, ['StartDate', 'EndDate'])}
                        handleInputChange={this.handleFilterInputChange}
                        translate={translate}
                        onRefreshTable={this.fetchData}
                        isLoading={resource.isLoading}
                        customHtml={
                            <PayDateFilter
                                queryFields={this.state.queryFilterFields}
                                updateQueryFields={this.updateQueryFields}
                                onQueryChange={this.handleFilterInputChange}
                                translate={translate}
                                hasDateType={false}
                                isClearDatesButtonVisible={false}
                            />
                        }
                    />

                    <ResourceTable
                        data={data}
                        fields={this.getFields()}

                        translate={translate}
                        isLoading={resource.isLoading}

                        options={this.state.tableOptions}

                        limit={this.state.queryFilterFields.limit.value}

                        sort={this.state.sort}
                        sortBy={this.state.sortBy}
                        onSortChange={this.handleUpdateSort}

                        onRowClick={checkPerm(Resources.PayrollBatchesItemsDocument, READ_PERM) && this.handleTogglePayrollView}
                        onView={checkPerm(Resources.PayrollBatchesItemsDocument, READ_PERM) && this.handleTogglePayrollView}
                        hasViewPerm={checkPerm(Resources.PayrollBatchesItemsDocument, READ_PERM)}
                    />

                    {/*Table footer*/}
                    <TableCardFooter
                        show={!(!data.length && !resource.isLoading)}
                    >
                        <Pagination
                            count={count}
                            isLoading={resource.isLoading}
                            handleQueryChange={
                                (name, value, currentPage) => name === 'offset'
                                    ? this.handleUpdateOffset(value, currentPage)
                                    : this.handleFilterInputChange(name, value)
                            }
                            pageOffset={this.state.offset}
                            queryFields={this.state.queryFilterFields}
                            translate={translate}
                        />
                    </TableCardFooter>

                    <NoRecords
                        show={(data.length === 0) && !resource.isLoading}
                        title={translate('text.no_records')}
                        addClass={'pt-16 pb-10'}
                    />
                </TableCard>

                <TableOptionsDialog
                    show={this.state.columnsModalOpen}
                    pagePath={this.pagePath}
                    columns={this.state.tableOptions.columns}
                    setTableColumnOptions={this.handleSetTableColumnOptions}
                    getDefaultTableColumnOptions={this.getDefaultTableColumnOptions}
                    onClose={this.handleToggleColumnSettingsDialog}
                    translate={translate}
                />

                {this.state.isPayrollViewDialogOpen && this.state.selectedSettlementItem && (
                    <ModalDefault
                        show={true}
                        widthClass="max-w-7xl"
                        limitHeight={true}
                        title={translate('modal_heading.payroll_statement')}
                        closeButtonLabel={translate('btn.close')}
                        onClose={this.handleTogglePayrollView}
                        hideDialogFooter={true}
                    >
                        <FileViewer
                            fileType="pdf"
                            filePath={Env.getApiUrl('api/' + Resources.PayrollBatchesItemsDocument, {
                                PayrollBatchEntryID: this.state.selectedSettlementItem.PayrollBatchEntryID,
                                token: getJWT().access_token,
                                type: 1
                            })}
                            onError={(e) => console.log(e)}
                        />
                    </ModalDefault>
                )}
            </React.Fragment>
        )
    }
}

export default connect(state => state)(SettlementItems)

function SettlementItemType({item, translate}) {
    const badges = []

    const referenceTypeBadge = {
        tbl_LoadDriverPay: {type: 'success', label: 'text.LoadPay'},
        tbl_LoadAccessorialDriverPay: {type: 'warning', label: 'text.Accessorial'},
        tbl_PayrollBatchEntryItem: {type: 'outline', label: 'text.PayrollItem'},
        tbl_ExpenseLine: {type: 'primary', label: 'text.ExpenseLine'},
        tbl_Reimbursement: item.Amount < 0
            ? {type: 'outline', label: 'text.AdvanceReturn'}
            : {type: 'success', label: 'text.Reimbursement'},
        tbl_DriverScheduledDeductions: {type: 'danger', label: 'text.ScheduledDeduction'},
    }

    const refBadge = referenceTypeBadge[item.ReferenceType]
    if (refBadge) {
        badges.push(<Badge key="ref" type={refBadge.type}>{translate(refBadge.label)}</Badge>)
    }

    if (item.ExpenseID && item.ReferenceType !== 'tbl_ExpenseLine') {
        badges.push(<Badge key="expense" type="primary">{translate('text.ExpenseID')}</Badge>)
    }

    if (item.IsAdvance) {
        badges.push(<Badge key="advance" type="outline">{translate('text.advance_given')}</Badge>)
    }

    if (item.IsEscrowUsage) {
        badges.push(<Badge key="escrow" type="outline">{translate('text.Escrow')}</Badge>)
    }

    if (item.IsGross) {
        badges.push(<Badge key="gross" type="outline">{translate('text.IsGross')}</Badge>)
    }

    return <div className="flex gap-1">{badges}</div>
}
